import React from "react";
import Forum from "../pages/forums/Forum";
import ForumDetails from "../pages/forums/ForumDetails";

export const forumRoutes = [
  { path: "/forums", element: <Forum /> },
  { path: "/forums/:forumId", element: <ForumDetails /> },
];
